import { GridColumn } from 'src/components/GridWrapper';
import CombineGLCodeDropDownCell from 'src/sections/receipt_details/CombinesDropdownCell';
import EditInput from 'src/sections/receipt_details/EditInput';
import EditUomInput from 'src/sections/receipt_details/EditUomInput';
import CurrentDocReceived from 'src/sections/receipt_details/lineItemsColumns/QuantityReceived';

export const ResultingLineItemColumns: GridColumn<any>[] = [
  {
    field: 'currentDocQty',
    title: 'Qty',
    width: '150px',
    editor: 'numeric',
    component: CurrentDocReceived,
    menu: false,
  },
  {
    field: 'item',
    title: 'Item #',
    width: '150px',
    component: EditInput,
    menu: false,
  },
  {
    field: 'itemDescription',
    title: 'Description',
    width: '150px',
    component: EditInput,
    menu: false,
  },
  {
    field: 'poglCode',
    title: 'GL Code',
    width: '150px',
    component: CombineGLCodeDropDownCell,
    menu: false,
  },
  {
    field: 'uom',
    title: 'UOM',
    width: '200px',
    component: EditUomInput,
    menu: false,
  },
];

export const CombineLineItemColumns = [
  {
    field: 'currentDocQty',
    title: 'Qty',
    width: '150px',
    menu: false,
  },
  {
    field: 'item',
    title: 'Item #',
    width: '150px',
    menu: false,
  },
  {
    field: 'itemDescription',
    title: 'Description',
    width: '150px',
    menu: false,
  },
  {
    field: 'poglCode',
    title: 'GL Code',
    width: '150px',
    menu: false,
  },
  {
    field: 'uom',
    title: 'UOM',
    width: '200px',
    menu: false,
  },
];
